import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

export const PLAN_ROWS: ReadonlyArray<Readonly<{ id: string; label: TranslationKey; value: TranslationKey }>> = [
	{
		id: 'ask',
		label: translationKey('corgi.vision_page.copilot.card.plan.ask.label'),
		value: translationKey('corgi.vision_page.copilot.card.plan.ask.value'),
	},
	{
		id: 'decision_maker',
		label: translationKey('corgi.vision_page.copilot.card.plan.decision_maker.label'),
		value: translationKey('corgi.vision_page.copilot.card.plan.decision_maker.value'),
	},
	{
		id: 'allies',
		label: translationKey('corgi.vision_page.copilot.card.plan.allies.label'),
		value: translationKey('corgi.vision_page.copilot.card.plan.allies.value'),
	},
];
